import i18n from 'i18next'
import * as Yup from 'yup'

export const validatePartnerValues = (VATIDConfig) => {
  return Yup.object().shape({
    name: Yup.string().required(i18n.t('required')),
    branch_office: Yup.number().required(i18n.t('required')),
    branch_office_id: Yup.number()
      .test('conditional-required', i18n.t('required'), function (value) {
        const { branch_office } = this.parent
        if (branch_office === 1) {
          return value != null && value !== ''
        }
        return true
      })
      .test('valid-number', 'Polje mora biti broj', function (value) {
        const { branch_office } = this.parent
        if (branch_office === 1 && value != null) {
          return !isNaN(value)
        }
        return true
      })
      .test('valid-digits', 'Broj mora imati 13 cifara', function (value) {
        const { branch_office } = this.parent
        if (branch_office === 1 && value != null) {
          const numStr = value.toString()
          return (
            numStr.length === 13 && Number.isInteger(Number(value)) && value >= 1000000000000 && value <= 9999999999999
          )
        }
        return true
      }),
    address_1: Yup.string().required(i18n.t('required')),
    country: Yup.string().required(i18n.t('required')),
    entity: Yup.string().test('conditional-required', i18n.t('required'), function (value) {
      const { state } = this.parent
      if (state === 'BA') {
        return value != null && value !== ''
      }
      return true
    }),
    currency_name: Yup.string().required(i18n.t('required')),
    zip_code: Yup.string().required(i18n.t('required')),
    city: Yup.string().required(i18n.t('required')),
    state: Yup.string().required(i18n.t('required')),
    id: Yup.string().test('id-number-length', function (value) {
      if (!VATIDConfig.partner_id_required) return true // not required, skip validation
      if (!value) return this.createError({ message: i18n.t('required') }) // required
      const regex = new RegExp(`^[A-Za-z0-9-\\s]{${VATIDConfig.partner_id_digit_limit}}$`)
      if (!regex.test(value)) {
        return this.createError({ message: i18n.t('invalid_id_format') })
      }
      return true
    }),
    vat: Yup.string().test('vat-number-length', function (value) {
      if (!VATIDConfig.partner_tax_required) return true // not required
      if (!value) return this.createError({ message: i18n.t('required') })
      const regex = new RegExp(`^[A-Za-z0-9]{${VATIDConfig.partner_tax_digit_limit}}$`)
      if (!regex.test(value)) {
        return this.createError({ message: i18n.t('invalid_vat_format') })
      }
      return true
    }),
    currency_id: Yup.string().required(i18n.t('required')),
    limit: Yup.number(),
    limit_num: Yup.number()
      .test('conditional-required', i18n.t('required'), function (value) {
        const { limit } = this.parent
        if (limit === 1) {
          return value != null && value !== ''
        }
        return true
      })
      .test('valid-number', 'Polje mora biti broj', function (value) {
        const { limit } = this.parent
        if (limit === 'Y' && value != null) {
          return !isNaN(value)
        }
        return true
      }),
  })
}
